import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import DataTable from '../components/Table/Table'
import { pxToRem, color } from '../utils'
import { newsActions, productMapActions } from '../actions'
import styled from 'styled-components'
import { ProductMapModal } from '../components/ProductModal'

const Content = styled.div`
  padding-top: ${pxToRem('24px')};
`

const ProductMapLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const columns = {
  product_id: {
    hide: true
  },
  datetime: {
    label: 'Data/Hora',
    sortable: false,
    width: pxToRem(10)
  },
  event: {
    label: 'Evento',
    sortable: false,
    width: pxToRem(10)
  },
  product: {
    label: 'Produto',
    sortable: false,
    align: 'left',
    width: pxToRem(2000)
  },
  provider: {
    label: 'Fornecedor',
    sortable: false,
    width: pxToRem(1100)
  },
  user: {
    label: 'Realizado Por',
    sortable: false,
    width: pxToRem(1100)
  },
}

class News extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductMapModal: false,
      debounce: undefined,
    }
  }

  componentDidMount() {
    this.props.fetchNews(this.props.areaId)
  }

  closeModal = () => {
    this.setState(state => ({
      openProductMapModal: false
    }))
  }

  openModal = (e, id) => {
    e.preventDefault()
    this.props.fetchProductMap(id)

    this.setState(state => ({
      openProductMapModal: true
    }))
  }

  componentDidUpdate(prevProps) {
    if (this.props.areaId && prevProps.areaId !== this.props.areaId) {
      const debounce = setTimeout(() => {
        this.props.fetchNews(this.props.areaId)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  render() {

  const {
    fetchNews,
    fetch_errors,
    fetching,
    news,
  } = this.props

  const {
    closeModal,
    openModal,
  } = this

  const { openProductMapModal, productMapStatusError } = this.state

  const CellComponent = ({ name, value, row, ...rest }) => {
    return (
      <ProductMapLink {...rest} onClick={e => openModal(e, row.product_id)}>
        {value}
      </ProductMapLink>
    )
  }

  columns['product'] = {
    ...columns['product'],
    CellComponent
  }

  return (
    <Fragment>
      {(news || []).length ? (
        <Content>
          <h2>Novidades</h2>
          <DataTable
            loading={fetching.news}
            error={fetch_errors.news}
            fetchData={fetchNews}
            columns={columns}
            height={900}
            width={1100}
            defaultSort={{ key: 'datetime', reverse: true }}
            data={(news || []).map(item => {
              return {
                ...item,
                product_id: item.product.id,
                product: item.product.name,
                provider: item.product.provider
              }
            })}
          />
        </Content>
      ) : null}

      <ProductMapModal
          open={openProductMapModal}
          closeModal={closeModal}
      />

    </Fragment>
    )
  }
}

const mapStateToProps = state => ({
    news: state.news.items,
    fetching: state.news.fetching,
    fetch_errors: state.news.fetch_errors,
    areaId: state.auth.areaId,
  })

  const mapDispatchToProps = dispatch => {
    return {
      fetchNews: (areaId) => {
        dispatch(newsActions.fetchNews(areaId))
      },
      fetchProductMap: id => {
        dispatch(productMapActions.fetchProductMap(id))
      },
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(News)



// WEBPACK FOOTER //
// ./src/containers/News.js